/**
 * rmh
 * 2018.08.30
 * 签署证据相关，删除，上传图片视频等
 */

import Vue from 'vue'
import {_geolocation, handleResponse, handleError, dealElement} from "../lib/common";
import ApiPort from "../config/api-port";
import HttpAxios from "./http-axios";
import GlobalConfig from '../config/global'

let junziqianApi = GlobalConfig.domain.junziqianApi
let domain = GlobalConfig.domain


export default {

  /**
   * 证据列表:提供于合同查看及上传证据使用
   * @param applyNo   签署编号;applyNo选传
   * @param signNo    签署流水号;signNo必传
   * @param sign
   * @param ts
   * @returns {Promise<T>}
   */
  viewList({applyNo, signNo, sign, ts}) {
    var url = junziqianApi + ApiPort.signEvidence.viewList;
    var jsonData = {applyNo: applyNo, signNo: signNo, sign: sign, ts: ts};
    jsonData = dealElement(jsonData);

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 上传视频
   * @param signNo
   * @param sign
   * @param ts
   * @param videoInput    频的file input
   * @returns {Promise<T>}
   */
  uploadVideo ({signNo, sign, ts, videoInput}) {
    var url = junziqianApi + ApiPort.signEvidence.video;
    var jsonData = {signNo: signNo, sign: sign, ts: ts, videoInput: videoInput};
    var formData = new FormData();
    jsonData = dealElement(jsonData);

    for(var key in jsonData) {
      formData.append(key, jsonData[key]);
    }

    return HttpAxios.postForm(url, formData).then(handleResponse).catch(handleError);
  },

  /**
   * 上传图片
   * @param signNo
   * @param sign
   * @param ts
   * @param imgdata   图片
   * @param imgType   存证图片类型:0身份证正面1身份证反面2赋强公正
   * @returns {Promise<T>}
   */
  uploadImage({signNo, sign, ts, imgdata, imgType}) {
    var url = junziqianApi + ApiPort.signEvidence.image;
    var jsonData = {signNo: signNo, sign: sign, ts: ts, imgdata: imgdata, imgType: imgType};

    return HttpAxios.post(url, jsonData);
  },

  /**
   * 打开页面就调用，检查data属性，true，结束轮询。用于检查过程证据是否完成，点击完成按钮
   * @param signNo
   * @param sign
   * @param ts
   * @returns {Promise<T>}
   */
  isFinish({signNo, sign, ts}) {
    let url = junziqianApi + ApiPort.signEvidence.isFinish;
    let jsonData = {signNo: signNo, sign: sign, ts: ts};

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  // 证据的封面和数量
  getViewInfo ({signNo, sign, ts}) {
    let jsonData = {signNo: signNo, sign: sign, ts: ts};
    var data = {data: null, size: 0}
    return this.getOne(jsonData).then((res) => {

      if (res.data) {
        data.data = res.data;
        return this.getSize(jsonData).then((size) => {
          data.size = size.data;
          return data
        })
      } else {
        return data
      }
    })
  },

  /**
   * 证据数量
   * @param signNo
   * @param sign
   * @param ts
   * @returns {Promise<T>}
   */
  getSize({signNo, sign, ts}) {
    let url = junziqianApi + ApiPort.signEvidence.getSize;
    let jsonData = {signNo: signNo, sign: sign, ts: ts};

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 证据封面
   * @param signNo
   * @param sign
   * @param ts
   * @param num
   * @returns {Promise<T>}
   */
  getOne({signNo, sign, ts, num}) {
    let url = junziqianApi + ApiPort.signEvidence.getOne;
    let jsonData = {signNo: signNo, sign: sign, ts: ts, num: num || 0};

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 设置完成状态，结束完成状态轮询
   * @param signNo
   * @param sign
   * @param ts
   * @returns {Promise<T>}
   */
  finish({signNo, sign, ts}) {
    let url = junziqianApi + ApiPort.signEvidence.finish;
    let jsonData={sign: sign, signNo:signNo, ts: ts}

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 取证详情界面,根据返回信息展示对应数据
   * @param isMobile      0web,1手机端
   * @param signNo        签字编号
   * @param sign
   * @param ts
   * @returns {Promise<T>}
   */
  extInfo ({isMobile, signNo, sign, ts}) {
    let url = junziqianApi + ApiPort.signEvidence.extInfo;
    let geolocation = _geolocation();
    let jsonData = {isMobile: isMobile, signNo: signNo, sign: sign, ts: ts, latitude: geolocation.latitude, longitude: geolocation.longitude};

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 删除证据,返回data中数量，表示未被删除的证据量
   * @param signNo
   * @param sign
   * @param ts
   * @param evidenceId      证据id
   * @returns {Promise<T>}
   */
  del ({signNo, sign, ts, evidenceId}) {
    let url = junziqianApi + ApiPort.signEvidence.del;
    let jsonData = {sign: sign, signNo: signNo, ts: ts, evidenceId: evidenceId};

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  }
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/signEvidence.js